
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase/client';

interface UseOrganizationDataResult {
  organizationData: any;
  daysRemaining: number | null;
  isTrialActive: boolean;
  isLoading: boolean;
}

export const useOrganizationData = (): UseOrganizationDataResult => {
  const [organizationData, setOrganizationData] = useState<any>(null);
  const [daysRemaining, setDaysRemaining] = useState<number | null>(null);
  const [isTrialActive, setIsTrialActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchOrganizationData = async () => {
      try {
        console.log("Tentative de récupération des données de l'organisation...");
        setIsLoading(true);
        
        const { data, error } = await supabase
          .from('organizations')
          .select('*')
          .single();
        
        if (error) {
          console.error("Erreur lors de la récupération des données de l'organisation:", error);
          return;
        }
        
        if (data) {
          console.log("Données de l'organisation récupérées:", data);
          setOrganizationData(data);
          
          // Vérifier si la période d'essai est active
          if (data.trial_ends_at) {
            const trialEndDate = new Date(data.trial_ends_at);
            const currentDate = new Date();
            
            console.log("Date de fin d'essai:", trialEndDate);
            console.log("Date actuelle:", currentDate);
            
            // Calculer le nombre de jours restants
            const timeDiff = trialEndDate.getTime() - currentDate.getTime();
            const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
            
            console.log("Jours restants calculés:", daysLeft);
            
            setDaysRemaining(daysLeft > 0 ? daysLeft : 0);
            setIsTrialActive(daysLeft > 0);
            
            console.log("isTrialActive défini à:", daysLeft > 0);
          } else {
            console.log("Pas de date de fin d'essai trouvée dans les données de l'organisation");
          }
        }
      } catch (error) {
        console.error("Exception lors de la récupération des données de l'organisation:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrganizationData();
  }, []);

  return { organizationData, daysRemaining, isTrialActive, isLoading };
};
